export function getValidationMessagesModalContent(messages, title = null) {
    return {
        title: title || 'An error occured',
        buttonText: 'OK',
        body:
            <ul className="list-group">
                {messages.map((error, index) => <li key={index} className="list-group-item" style={{ fontSize: '16px' }}>{error}</li>)}
            </ul>
    };
}

export function currencyFormat(num) {
    if (!num) {
        return '';
    } else {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
}

export function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

export function cardStatusType(param){
    switch(param?.toLowerCase()){
        // case 'blue':
        //     return 'border-primary';
        case 'red':
            return 'border-danger';
        case 'yellow':
            return 'border-warning';
        case 'green':
            return 'border-success';
        default:
            return '';
    };
};

export function textStatusType(param){
    switch(param?.toLowerCase()){
        case 'blue':
            return 'text-ph-blue';
        case 'red':
            return 'text-danger';
        case 'yellow':
            return 'text-warning';
        case 'green':
            return 'text-success';
        default:
            return '';
    };
};

export function formatDate(date) {
    if (!!date && date.indexOf('T') !== -1) {
        const result = date?.split('T')[0];
        return result;
    }
    if (!!date && date.indexOf('/') !== -1) {
        let [month, day, year] = date.split('/');

        // Ensure two-digit month and day format
        month = month.padStart(2, '0');
        day = day.padStart(2, '0');

        // Format the date as YYYY-MM-DD
        let result = `${year}-${month}-${day}`;
        return result;
    }
    return "";
}

export function formatDateAsUS(inputDateString) {
    if (!!inputDateString) {
        var parts = inputDateString.split('-');
        if (parts.length === 3) {
            var year = parts[0];
            var month = parts[1];
            var day = parts[2];

            // Format the date as MM/DD/YYYY
            return month + '/' + day + '/' + year;
        } else {
            // Invalid date format
            return 'Invalid Date';
        }
    }
    else {
        return '';
    }
}

export function formatPhoneNumber(value, country) {
    if (!value || (country !== "US" && country !== "CA")) return value;
    const phonenumber = value.replace(/[^\d]/g, '');
    const phonelength = phonenumber.length;
    if (phonelength < 4) return phonenumber;
    if (phonelength <= 6) return `(${phonenumber.slice(0, 3)}) ${phonenumber.slice(3)}`;
    if (phonelength > 6 && phonelength < 10) return `(${phonenumber.slice(0, 3)}) ${phonenumber.slice(3, 6)}-${phonenumber.slice(6)}`;
    if (phonelength > 10) return `(${phonenumber.slice(0, 3)}) ${phonenumber.slice(3, 6)}-${phonenumber.slice(6, 10)} x${phonenumber.slice(10)}`;

    return `(${phonenumber.slice(0, 3)}) ${phonenumber.slice(3, 6)}-${phonenumber.slice(6)}`;
}

export function getUrlParams() {
    const currentUrl = new URL(window.location.href);
    const currentUrlParams = currentUrl.searchParams;
    const urlParamsArray = Array.from(currentUrlParams.entries());
    return urlParamsArray;
}